import { getBasicConfig } from '@/api/system/dict';
import { getParamsDetail } from '@/api/system/param'
import { getList } from '@/api/system/productManagement';
import { getDeptTreeDataScope } from '@/api/system/dept';
import { setStore, getStore } from '@/util/store';
import {getCascade} from '@/api/user'
import { getListAll } from '@/api/system/leasePaymentType'
const comDict = {
  state: {
    companies: getStore({ name: 'companies' }) || [], /// 公司列表
    porductTypes: getStore({ name: 'porductTypes' }) || [], /// 类型列表
    porductCascader: getStore({ name: 'porductCascader' }) || [], /// 产品类型 利率 - 租期 联动
    productCascaderType: getStore({name: 'productCascaderType'}) || [], /// 产品类型与默认租付类型联动
    baoyinQuery: getStore({name: 'baoyinQuery'}) || '', /// 友融推送进件特定deptId
  },
  mutations: {
    SET_COMPANY(state, info) {
      state.companies = info;
      setStore({ name: 'companies', content: state.companies });
    },
    SET_PORDUCT(state, info) {
      state.porductTypes = info;
      setStore({ name: 'porductTypes', content: state.porductTypes });
    },
    SET_PORDUCT_CASCADER(state, info) {
      state.porductCascader = info;
      setStore({ name: 'porductCascader', content: state.porductCascader });
    },
    SET_PRODUCT_CASCADER_TYPE (state, info) {
      state.productCascaderType = info
      setStore({ name: 'productCascaderType', content: state.productCascaderType })
    },
    SET_BAO_YIN_QUERY (state, info = {}) {
      state.baoyinQuery = info?.paramValue
      setStore({ name: 'baoyinQuery', content: state.baoyinQuery })
    }

  },
  actions: {
    fetchPorductCascader({ commit }) {
      return new Promise(async (resolve, reject) => {
        let res;
        try {
          res = await getCascade();
          if (res.status == 200 && res.data.code == 200) {
            let list = res.data.data;
            commit('SET_PORDUCT_CASCADER', list);
            return resolve();
          }
          throw new Error('出错了！');
        } catch (err) {
          return reject();
        }
      }).catch(error => {
        reject(error);
      });
    },
    fetchProductTypes({ commit }) {
      return new Promise(async (resolve, reject) => {
        let res;
        try {
          res = await getList();
          if (res.status == 200 && res.data.code == 200) {
            let list = res.data.data;
            let newList = list.map((item, index) => ({
              ...item, // 使用扩展运算符复制原对象的所有属性
              label: item.productName, // 添加新的label属性
              value: item.productValue, // 添加新的value属性
            }));
            commit('SET_PORDUCT', newList);
            return resolve();
          }
          throw new Error('出错了！');
        } catch (err) {
          return reject();
        }

        // getList().then(res => {
        //     const data = res.data.data;
        //     if (res.status == 200 && res.data.code == 200) {
        //         let list = res.data.data;
        //         let newList = list.map((item, index) => ({
        //             ...item, // 使用扩展运算符复制原对象的所有属性
        //             label: item.productName, // 添加新的label属性
        //             value: item.productValue // 添加新的value属性
        //         }));
        //         commit('SET_PORDUCT', newList);
        //     }
        // });
      }).catch(error => {
        reject(error);
      });
    },
    fetchCompanies({ commit }) {
      return new Promise((resolve, reject) => {
        getDeptTreeDataScope({}).then(res => {
          if (res.status == 200 && res.data.code == 200) {
            commit('SET_COMPANY', res.data.data);
          }
        });
        resolve();
      }).catch(error => {
        reject(error);
      });
    },
    // 获取产品类型与默认租付类型联动
    fetchProductCascaderType({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const { status, data } = await getListAll();
          if (status !== 200 && data.code !== 200) throw new Error('出错了！')
          commit('SET_PRODUCT_CASCADER_TYPE', data.data);
          return resolve()
        } catch (err) {
          return reject()
        }
      }).catch(error => {
        reject(error)
      })
    },
    getBaoyinQuery({ commit }) {
      return new Promise(async(resolve, reject) => {
        try {
          const { status, data } = await getParamsDetail('baoyin_loan_post_id')
          console.log(status, data);
          if (status !== 200 && data.code !== 200) throw new Error('出错了！')
          commit('SET_BAO_YIN_QUERY', data.data);
          return resolve()
        } catch (error) {
          return reject(error)
        }
      })
    }
  },
};

export default comDict;
